// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IWvxE","col":"styles_col__1jDGB","actions":"styles_actions__3CdAD","conflict":"styles_conflict__KFnzH"};